var map = {
	"./assets/images/developer/mobile/head-banner.jpg": "d2f8",
	"./assets/images/developer/pc/head-banner.jpg": "af10",
	"./assets/images/procution/mobile/head-banner.jpg": "ed99",
	"./assets/images/procution/pc/head-banner.jpg": "fe65",
	"./assets/images/universities/mobile/head-banner.jpg": "bf60",
	"./assets/images/universities/pc/head-banner.jpg": "c19d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3521";